import React, { useState, createContext } from 'react';
import moment from 'moment';

export const MyContext = createContext();

export const MyContextProvider = props => {


    const [pause_audio,setPauseAudio]=useState(false);
    const [conversation_date,setConversationDate]=useState(moment(new Date()).format("YYYY-MM-DD"))
   


 








    return <MyContext.Provider value={{PauseAudio:[pause_audio,setPauseAudio],ConversationDate:[conversation_date,setConversationDate]}}> {props.children} </MyContext.Provider>;






}